import { useCompatRouter } from "@website/hooks/compat-router";
import { useEffect, useLayoutEffect, useState } from "react";
export const usePopover = ({
  initialOpen = false
}: {
  initialOpen?: boolean;
}) => {
  const [open, setOpen] = useState<boolean>(false);
  const router = useCompatRouter();
  useLayoutEffect(() => {
    if (initialOpen) onOpenPopover();
  }, []);
  useEffect(() => {
    if (open) {
      function close() {
        setOpen(false);
      }
      window.addEventListener("popstate", close);
      return () => window.removeEventListener("popstate", close);
    }
  }, [open]);
  const onClosePopover = () => {
    router.back();
  };
  const onOpenPopover = () => {
    window.history.pushState(null, "", "");
    setTimeout(() => setOpen(true), 100);
  };
  return {
    open,
    onOpenPopover,
    onClosePopover,
    popoverProperties: {
      animate: "bottom" as const,
      open,
      onClose: onClosePopover,
      position: "end" as const,
      gapHorizontal: "-24px",
      gapVertical: "-16px"
    }
  };
};